// components/InstallButton.jsx
import React, { useState, useEffect } from 'react';
import { Button, Tooltip } from '@mui/material';
import { InstallMobile as InstallIcon, GetApp as GetAppIcon } from '@mui/icons-material';

const InstallButton = ({ language }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowButton(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Check if already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (isStandalone) {
      setShowButton(false);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setShowButton(false);
    }
    
    setDeferredPrompt(null);
  };

  if (!showButton) return null;

  return (
    <Tooltip title={language === 'ar' ? 'تثبيت التطبيق' : 'Install App'}>
      <Button
        variant="contained"
        onClick={handleInstall}
        startIcon={<InstallIcon />}
        sx={{
          backgroundColor: '#FFD700',
          color: '#000000',
          '&:hover': {
            backgroundColor: '#FFE55C'
          }
        }}
      >
        {language === 'ar' ? 'تثبيت' : 'Install'}
      </Button>
    </Tooltip>
  );
};

export default InstallButton;